import { Link } from 'react-style-guide';
import React, { useEffect, useState } from 'react';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { HomePageCarousel } from './HomePageCarousel';
import useFriendsPresence from '../common/hooks/useFriendsPresence';
import bedev1Services from '../common/services/bedev1Services';
import ErrorStatus from '../common/components/ErrorStatus';
import { homePage } from '../common/constants/configConstants';
import { LoadingGameTile } from '../common/components/LoadingGameTile';
import { buildSortDetailUrl } from '../common/utils/browserUtils';
import { CommonGameSorts, FeaturePlacesList } from '../common/constants/translationConstants';
import { TPageType, TGetOmniRecommendationsResponse } from '../common/types/bedev1Types';
import personalizationTranslationConfig from '../../../js/react/realTimePlaceLists/translation.config';

const { maxTilesPerCarouselPage } = homePage;
export const HomePage = ({ translate }: WithTranslationsProps): JSX.Element => {
  const friendsPresence = useFriendsPresence();
  const [recommendations, setRecommendations] = useState<
    TGetOmniRecommendationsResponse | undefined
  >(undefined);
  const [error, setError] = useState<boolean>(false);

  const fetchRecommendations = async () => {
    setError(false);
    try {
      const data = await bedev1Services.getOmniRecommendations(TPageType.Home);
      setRecommendations(data);
    } catch {
      setError(true);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchRecommendations();
  }, []);

  if (error) {
    return (
      <div className='game-home-page-container'>
        <h3>{translate(CommonGameSorts.LabelGames)}</h3>
        <ErrorStatus
          errorMessage={translate(CommonGameSorts.LabelApiError)}
          onRefresh={fetchRecommendations}
        />
      </div>
    );
  }

  if (recommendations === undefined) {
    return (
      <div className='game-home-page-container'>
        <div className='game-home-page-loading-title shimmer' />
        <div className='game-home-page-loading-carousel'>
          {Array.from({ length: maxTilesPerCarouselPage }, (_, id) => (
            // eslint-disable-next-line react/no-array-index-key
            <LoadingGameTile key={id} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className='game-home-page-container'>
      {recommendations.Sorts.map((sort, positionId) => {
        const gameData = sort.RecommendationList.map(
          ({ ContentType, ContentId }) => recommendations.ContentMetadata[ContentType][ContentId]
        )
          .filter(recommendation => recommendation !== undefined)
          .slice(0, maxTilesPerCarouselPage);
        return (
          <React.Fragment key={sort.Topic}>
            <div className='game-home-page-carousel-title'>
              <Link url={buildSortDetailUrl(sort.Topic)} className='font-header-1'>
                {sort.Topic}
              </Link>
              <Link url={buildSortDetailUrl(sort.Topic)} className='see-all-link-icon'>
                {translate(FeaturePlacesList.ActionSeeAll)}
              </Link>
            </div>
            <HomePageCarousel
              sort={sort}
              gameData={gameData}
              translate={translate}
              positionId={positionId}
              friendsPresence={friendsPresence}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default withTranslations(HomePage, personalizationTranslationConfig);
